import React from 'react';
import { StarIcon } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
import { Reveal } from './ui/Reveal';
export function SocialProofStrip() {
  return <section aria-label="Testimonios de familias" className="border-b border-line bg-ink" data-id="element-233" data-mp="30ooduj8vip6t">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-8 lg:py-16" style={{
      paddingTop: "18px",
      paddingBottom: "20px"
    }} data-id="element-234" data-mp="35nhtah7q0q9m">
        <ul className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-235" data-mp="2rmoz5xlbzx71">
          {shortTestimonials.map((t, i) => <Reveal key={t.name} delay={i * 0.04} className="h-full" data-id="element-236" data-mp="2wnkydxuqmv64" data-mpi={i}>
              <li className="flex h-full flex-col rounded-2xl border border-line bg-surface p-5" data-id="element-237" data-mp="2hq2b6zxpkq0s">
                <div className="flex items-center gap-3" data-id="element-238" data-mp="2mo3thinb8lb7">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-surfaceAlt text-sm font-bold text-accent" style={{
                fontSize: "10px"
              }} data-id="element-239" data-mp="2mqq1tki0z4uh">
                    {t.initials}
                  </span>
                  <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-240" data-mp="2v5dk1i3ito6h">
                    {Array.from({
                  length: 5
                }).map((_, s) => <StarIcon key={s} aria-hidden="true" className="h-3 w-3 fill-accent text-accent" data-id="element-241" data-mp="2q57z0krrazxd" data-mpi={s} />)}
                  </span>
                </div>
                <blockquote className="mt-4 text-[15px] leading-relaxed text-ivory" style={{
              fontSize: "11px"
            }} data-id="element-242" data-mp="2zxwzkklrqtdx">
                  “{t.quote}”
                </blockquote>
                <p className="mt-auto pt-5 text-sm font-semibold text-muted" style={{
              fontSize: "10px",
              paddingTop: "0px",
              fontWeight: "400"
            }} data-id="element-243" data-mp="27984b27e9ia3">
                  {t.name}, {t.city}
                </p>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}